import React from "react";
import { useDeleteMergedViewMutation } from "graphql/types/graphql";
import GenericDeleteButton from "./GenericDeleteButton";
import { ContextData } from "@/utils/Provider";

interface DeleteMergedViewButtonProps {
  cubeId: string;
  viewName: string;
  onDelete?: () => void;
  disableDeleteButton?: boolean;
}

const DeleteMergedViewButton: React.FC<DeleteMergedViewButtonProps> = ({
  cubeId,
  viewName,
  onDelete,
  disableDeleteButton = false,
}) => {
  const [deleteMergedView, { loading }] = useDeleteMergedViewMutation({
    update: (cache) => {
      cache.evict({
        id: "ROOT_QUERY",
        fieldName: "views",
      });
    },
  });

  const getMutationVariables = (itemId: string, contextData: ContextData) => {
    return {
      cubeId: cubeId,
      viewName: itemId,
    };
  };

  const truncatedItemName = viewName.length > 30 ? `${viewName.slice(0, 30)}...` : viewName;

  return (
    <GenericDeleteButton
      itemId={viewName}
      onDelete={onDelete}
      itemName={truncatedItemName}
      confirmationMessage={`Are you sure you want to delete the merged view ?`}
      disableDeleteButton={disableDeleteButton}
      mutationFn={deleteMergedView}
      mutationLoading={loading}
      getMutationVariables={getMutationVariables}
      successMessage="Merged view deleted successfully!"
      deleteTooltip="Delete Merged View"
    />
  );
};

export default DeleteMergedViewButton;
